import React, { forwardRef } from 'react'
import { Link as RouterLink } from 'react-router-dom'
import withStyles from '@mui/styles/withStyles'
import classnames from 'classnames'
import QAPVars from 'qap/vars'

import type { ReactNode } from 'react'

type Props = {
  children: ReactNode;
  to: string;
  className?: string;
  hideUnderline?: boolean;
  classes: any;
};

export const styles = {
  root: {
    color: QAPVars.linkBlue,
    textDecoration: 'none',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  hideUnderline: {
    '&:hover': {
      textDecoration: 'none',
    },
  },
} as const

const Link = (props: Props, ref: ((arg1: null) => unknown) | {
  current: null;
}) => {
  const { classes, className, hideUnderline, ...rest } = props
  const classNames = classnames(className, hideUnderline && classes.hideUnderline, classes.root)

  return (
    <RouterLink ref={ref} className={classNames} {...rest} />
  )
}

// @ts-expect-error - TS2345 - Argument of type '(props: Props, ref: { current: null; } | ((arg1: null) => unknown)) => JSX.Element' is not assignable to parameter of type 'ForwardRefRenderFunction<null, Props>'.
export default withStyles(styles)(forwardRef(Link))
